"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimeUnit = exports.SubCategory = exports.Category = exports.STREAM_STATUS_CODE = exports.AccountType = exports.ActivityActionCode = exports.ACTION_CODES = void 0;
/**
 * Codes for identifying user actions supported by this client.
 */
var ACTION_CODES;
(function (ACTION_CODES) {
    ACTION_CODES[ACTION_CODES["ScheduleOneTimePayment"] = 1] = "ScheduleOneTimePayment";
    ACTION_CODES[ACTION_CODES["CreateStream"] = 2] = "CreateStream";
    ACTION_CODES[ACTION_CODES["CreateStreamWithFunds"] = 3] = "CreateStreamWithFunds";
    ACTION_CODES[ACTION_CODES["AddFundsToAccount"] = 4] = "AddFundsToAccount";
    ACTION_CODES[ACTION_CODES["WithdrawFromStream"] = 5] = "WithdrawFromStream";
    ACTION_CODES[ACTION_CODES["PauseStream"] = 6] = "PauseStream";
    ACTION_CODES[ACTION_CODES["ResumeStream"] = 7] = "ResumeStream";
    ACTION_CODES[ACTION_CODES["ProposeUpdate"] = 8] = "ProposeUpdate";
    ACTION_CODES[ACTION_CODES["AnswerUpdate"] = 9] = "AnswerUpdate";
    ACTION_CODES[ACTION_CODES["CreateAccount"] = 10] = "CreateAccount";
    ACTION_CODES[ACTION_CODES["CloseStream"] = 11] = "CloseStream";
    ACTION_CODES[ACTION_CODES["CloseAccount"] = 12] = "CloseAccount";
    ACTION_CODES[ACTION_CODES["TransferStream"] = 13] = "TransferStream";
    ACTION_CODES[ACTION_CODES["WithdrawFromAccount"] = 14] = "WithdrawFromAccount";
})(ACTION_CODES = exports.ACTION_CODES || (exports.ACTION_CODES = {}));
var ActivityActionCode;
(function (ActivityActionCode) {
    ActivityActionCode[ActivityActionCode["Unknown"] = 0] = "Unknown";
    ActivityActionCode[ActivityActionCode["AccountCreated"] = 10] = "AccountCreated";
    ActivityActionCode[ActivityActionCode["AccountCreatedWithTemplate"] = 20] = "AccountCreatedWithTemplate";
    ActivityActionCode[ActivityActionCode["StreamTemplateUpdated"] = 30] = "StreamTemplateUpdated";
    ActivityActionCode[ActivityActionCode["FundsAddedToAccount"] = 40] = "FundsAddedToAccount";
    ActivityActionCode[ActivityActionCode["FundsWithdrawnFromAccount"] = 50] = "FundsWithdrawnFromAccount";
    ActivityActionCode[ActivityActionCode["AccountDataRefreshed"] = 60] = "AccountDataRefreshed";
    ActivityActionCode[ActivityActionCode["StreamCreated"] = 70] = "StreamCreated";
    ActivityActionCode[ActivityActionCode["FundsAllocatedToStream"] = 80] = "FundsAllocatedToStream";
    ActivityActionCode[ActivityActionCode["FundsWithdrawnFromStream"] = 90] = "FundsWithdrawnFromStream";
    ActivityActionCode[ActivityActionCode["StreamPaused"] = 110] = "StreamPaused";
    ActivityActionCode[ActivityActionCode["StreamResumed"] = 120] = "StreamResumed";
    ActivityActionCode[ActivityActionCode["StreamClosed"] = 140] = "StreamClosed";
})(ActivityActionCode = exports.ActivityActionCode || (exports.ActivityActionCode = {}));
/**
 * Treasury type
 */
var AccountType;
(function (AccountType) {
    AccountType[AccountType["Open"] = 0] = "Open";
    AccountType[AccountType["Lock"] = 1] = "Lock";
})(AccountType = exports.AccountType || (exports.AccountType = {}));
/**
 * Stream status codes.
 */
var STREAM_STATUS_CODE;
(function (STREAM_STATUS_CODE) {
    STREAM_STATUS_CODE[STREAM_STATUS_CODE["Scheduled"] = 0] = "Scheduled";
    STREAM_STATUS_CODE[STREAM_STATUS_CODE["Running"] = 1] = "Running";
    STREAM_STATUS_CODE[STREAM_STATUS_CODE["Paused"] = 2] = "Paused";
    STREAM_STATUS_CODE[STREAM_STATUS_CODE["Unknown"] = 99] = "Unknown";
})(STREAM_STATUS_CODE = exports.STREAM_STATUS_CODE || (exports.STREAM_STATUS_CODE = {}));
// Primary category of tresury accounts
var Category;
(function (Category) {
    Category[Category["default"] = 0] = "default";
    Category[Category["vesting"] = 1] = "vesting";
})(Category = exports.Category || (exports.Category = {}));
// Sub categories of vesting accounts
var SubCategory;
(function (SubCategory) {
    SubCategory[SubCategory["default"] = 0] = "default";
    SubCategory[SubCategory["advisor"] = 1] = "advisor";
    SubCategory[SubCategory["development"] = 2] = "development";
    SubCategory[SubCategory["foundation"] = 3] = "foundation";
    SubCategory[SubCategory["investor"] = 4] = "investor";
    SubCategory[SubCategory["marketing"] = 5] = "marketing";
    SubCategory[SubCategory["partnership"] = 6] = "partnership";
    SubCategory[SubCategory["seed"] = 7] = "seed";
    SubCategory[SubCategory["team"] = 8] = "team";
    SubCategory[SubCategory["community"] = 9] = "community";
})(SubCategory = exports.SubCategory || (exports.SubCategory = {}));
// Preferred Time Unit
var TimeUnit;
(function (TimeUnit) {
    TimeUnit[TimeUnit["Second"] = 0] = "Second";
    TimeUnit[TimeUnit["Minute"] = 60] = "Minute";
    TimeUnit[TimeUnit["Hour"] = 3600] = "Hour";
    TimeUnit[TimeUnit["Day"] = 86400] = "Day";
    TimeUnit[TimeUnit["Week"] = 604800] = "Week";
    TimeUnit[TimeUnit["Month"] = 2629750] = "Month";
    TimeUnit[TimeUnit["Year"] = 31557000] = "Year";
})(TimeUnit = exports.TimeUnit || (exports.TimeUnit = {}));
